import Organization from './Organization'

export default Organization
